export const ERROR_I18N_ENTRIES = {
  error_Data1: {
    es: '<p>Error</p>',
    en: '<p>Error</p>',
    pt: '<p>Error</p>',
    fr: '<p>Error</p>',
  },
  error_Data2: {
    es: '<p>Ups, en estos momentos no es posible\n detectar la señal que deseas, vuelve a la página principal.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  error_Data3: {
    es: '<p>IR A LA PÁGINA PRINCIPAL</p>',
    en: '<p>GO TO HOMEPAGE</p>',
    pt: '<p>IR PARA A PÁGINA PRINCIPAL</p>',
    fr: '<p>ALLER À LA PAGE PRINCIPALE</p>',
  },
};
